export const insightsPath = {
    DASHBOARD: 'dashboardinsights',
    PRODUCT: 'productsinsights',
    COMPLAINTS: 'complaintsinsights',
};

export const listPath = {
    PRODUCT: 'productlist',
    COMPLAINTS: 'servicerequestlist',
    QRCODE: 'qrcodelist'
}

export const uploadPath = {
    PRODUCT: {
        PRODUCT_UPLOAD: 'productupload',
        BILL_UPLOAD: 'productBillupload',
    },
    COMPLAINTS: {
        COMPLAINTS_UPLOAD: 'complaintupload',
        BILL_UPLOAD: 'complaintBillupload',
    },
}